import React, { createContext, useContext, useState, useMemo } from 'react'
import PropTypes from 'prop-types'

const FetchStateContext = createContext()

export const FetchStateProvider = ({ children }) => {
    const [isFetching, setIsFetching] = useState(false)
    const [dataFetched, setDataFetched] = useState(false)

    const value = useMemo(
        () => ({
            isFetching,
            setIsFetching,
            dataFetched,
            setDataFetched,
        }),
        [isFetching, dataFetched],
    )

    return (
        <FetchStateContext.Provider value={value}>
            {children}
        </FetchStateContext.Provider>
    )
}

FetchStateProvider.propTypes = {
    children: PropTypes.node,
}

export const useFetchState = () => useContext(FetchStateContext)
